import BreakDownIndicator from './BreakDownIndicator';

export default BreakDownIndicator;
